<template>
  <div class="square-card-form">
    <div :id="containerId" data-testid="square_card_container"></div>
    <div class="text-danger" role="alert" v-if="localError" data-testid="square_card_error">{{ $t(localError) }}</div>
    <button type="button" class="btn btn-primary paybtn" data-testid="square_card_submit"
            :data-teststate="ready ? 'ready' : 'loading'"
            :disabled="disabled || busy || !ready" @click="submit">
      <slot>{{ $t('message.card.submit') }}</slot>
    </button>
  </div>
</template>

<script>
// Square Web Payments SDK のカード入力欄 + 3DS(STORE) + tokenize。
// 成功時は @tokenized({nonce, verificationToken}) を出すだけで、その後（登録API/差し替えAPI）は親が決める。
// Register.vue（申込時の登録）と CardChange.vue（与信NG後の差し替え #226）で共用。
import { attachCard, tokenizeWith3ds } from '@/lib/squarePayments'

export default {
  name: 'SquareCardForm',
  props: {
    applicationId: { type: String, required: true },
    locationId: { type: String, required: true },
    environment: { type: String, default: 'sandbox' },
    locale: { type: String, default: 'ja' },
    buyer: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    containerId: { type: String, default: 'square-card-container' }
  },
  data () {
    return { payments: null, card: null, ready: false, busy: false, localError: '' }
  },
  async mounted () {
    await this.attach()
  },
  beforeDestroy () {
    this.destroyCard()
  },
  methods: {
    async attach () {
      this.localError = ''
      this.ready = false
      await this.destroyCard()
      try {
        const res = await attachCard(this.applicationId, this.locationId, this.environment, '#' + this.containerId, this.locale)
        this.payments = res.payments
        this.card = res.card
        this.ready = true
        this.$emit('ready')
      } catch (e) {
        this.localError = 'message.card.form_init_error'
        this.$emit('error', this.localError)
      }
    },
    async destroyCard () {
      if (this.card) {
        try { await this.card.destroy() } catch (e) {}
        this.card = null
      }
    },
    async submit () {
      if (this.busy || !this.ready) return
      this.busy = true
      this.localError = ''
      try {
        const tok = await tokenizeWith3ds(this.payments, this.card, 0, 'JPY', this.buyer)
        this.$emit('tokenized', tok)
      } catch (e) {
        this.localError = 'message.card.form_tokenize_error'
        this.$emit('error', this.localError)
      } finally {
        this.busy = false
      }
    }
  }
}
</script>
